<template>
  <div class="grid grid-cols-12 gap-3">
    <TextField
      v-if="showName"
      v-model="addressName"
      :label="nameLabel"
      label-class="col-span-12"
    />
    <TextField
      v-if="!hideStreet"
      v-model="addressStreet"
      label="Street"
      label-class="col-span-9"
    />
    <TextField
      v-if="!hideStreet"
      v-model="addressUnit"
      label="Unit"
      label-class="col-span-3"
    />
    <TextField
      v-model="addressCity"
      label="City"
      label-class="col-span-6"
      data-cy="address-city"
    />
    <div class="col-span-3">
      <Select
        v-model="addressState"
        label="State"
        search
        class="stateInput"
        :options="STATE_OPTIONS"
        data-cy="address-state"
      />
    </div>
    <TextField
      v-model="addressZip"
      label="Zip Code"
      label-class="col-span-3"
      :error-message="firstErrorMessage(v$.zip_code)"
      data-cy="address-zip-code"
    />
  </div>
</template>
<script setup lang="ts">
import { STATE_OPTIONS } from "serviceshift-ui/shared/src/lib/stateOptions";
import { computed } from "vue";
import { firstErrorMessage } from "@/lib/vuelidate_helpers";

import TextField from "@/components/TextField.vue";
import { Address } from "@/typings/address";
import { Validation } from "@vuelidate/core";

const props = withDefaults(
  defineProps<{
    modelValue: Address;
    showName?: boolean;
    nameLabel?: string;
    hideStreet?: boolean;
    v$?: Validation;
  }>(),
  {
    showName: false,
    nameLabel: "Name",
    hideStreet: false,
    v$: null
  }
);

const emit = defineEmits(["update:modelValue"]);

const address = computed(() => {
  return props.modelValue;
});

const addressName = computed({
  get() {
    return address.value.name;
  },
  set(val) {
    emit("update:modelValue", { ...address.value, name: val });
  }
});

const addressStreet = computed({
  get() {
    return address.value.street;
  },
  set(val) {
    emit("update:modelValue", { ...address.value, street: val });
  }
});

const addressUnit = computed({
  get() {
    return address.value.unit;
  },
  set(val) {
    emit("update:modelValue", { ...address.value, unit: val });
  }
});

const addressCity = computed({
  get() {
    return address.value.city;
  },
  set(val) {
    emit("update:modelValue", { ...address.value, city: val });
  }
});

const addressState = computed({
  get() {
    return address.value.state;
  },
  set(val) {
    emit("update:modelValue", { ...address.value, state: val });
  }
});

const addressZip = computed({
  get() {
    return address.value.zip_code;
  },
  set(val) {
    emit("update:modelValue", { ...address.value, zip_code: val });
  }
});
</script>
